import api from "../api";

export const useUserPasswordChange = (data) =>
  api.put("/user/change-password", data).then((res) => res.data);
